import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import '@geoman-io/leaflet-geoman-free'
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'

// Leaflet's default marker icon references images by relative URL, which 404s
// under a bundler. Point the default icon at the bundled assets instead.
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
})

export function createBaseLayers() {
  return {
    Street: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors',
    }),
    Satellite: L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      { maxZoom: 19, attribution: 'Tiles &copy; Esri, Maxar, Earthstar Geographics' },
    ),
    Terrain: L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
      maxZoom: 17,
      attribution: 'Map data: &copy; OpenStreetMap contributors, SRTM | &copy; OpenTopoMap',
    }),
    Dark: L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      maxZoom: 20,
      subdomains: 'abcd',
      attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
    }),
  }
}

// `interactive: false` is used for the dimmed landing-page background map.
export function createMap(container, { interactive = true, center = [20, 0], zoom = 2 } = {}) {
  const layers = createBaseLayers()
  const map = L.map(container, {
    center,
    zoom,
    layers: [layers.Street],
    zoomControl: interactive,
    attributionControl: interactive,
    ...(interactive
      ? {}
      : {
          dragging: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          boxZoom: false,
          keyboard: false,
          touchZoom: false,
          tap: false,
        }),
  })
  if (interactive) {
    L.control.layers(layers, {}, { position: 'topright' }).addTo(map)
  }
  return { map, layers }
}

// Geoman drawing/editing toolbar. Measure is handled by our own toggle (see
// measure.js), so it is not part of the Geoman control set.
export function setupDrawing(map) {
  map.pm.addControls({
    position: 'topleft',
    drawMarker: true,
    drawPolyline: true,
    drawPolygon: true,
    drawRectangle: true,
    drawCircle: true,
    drawCircleMarker: false,
    drawText: false,
    editMode: true,
    dragMode: true,
    cutPolygon: false,
    removalMode: true,
    rotateMode: false,
  })
  // Snapping is on by default, but widen the catch radius so points reliably
  // snap to each other (and to segments) while drawing AND while dragging
  // vertices in edit/drag mode.
  map.pm.setGlobalOptions({
    snappable: true,
    snapDistance: 30,
    snapSegment: true,
    snapMiddle: false,
  })
}

export { L }
